import React, { useState, useCallback } from 'react';

import { FeatureLabelsContainer } from './FeatureLabelsContainer';
import { OfferLabelsContainer } from './OfferLabelsContainer';
import { useApplicationContext } from '../../../../../../shared/utils/applicationContext';
import { Gallery } from '../../../components/Gallery';
import { OfferGalleryPessimizationFlexible } from '../../../components/OfferGalleryPessimizationFlexible';
import { useOfferContext } from '../../../context';
import { useAutoScrollContext } from '../../../context/AutoScrollContext';
import { isNewbuildingBooked, isNewbuildingBookedFromDeveloper } from '../../../utils/newbuildingBooking';

export function GalleryContainer() {
  const { index, media, thumbnails, tracking, offer, autoScrollSettings, isNewbuilding } = useOfferContext();
  const { config } = useApplicationContext();

  const isBookedFromCian = isNewbuildingBooked(offer, config);
  const isBookedFromDeveloper = isNewbuildingBookedFromDeveloper(offer);

  const [clicked, setClicked] = useState(false);
  const isFlexibleSanctions = config.get<boolean>('Moderation.CustomSanction.NewModerationInfo.Enabled');
  const isV2BookedFromDeveloperEnabled = config.get<boolean>('Newbuilding.BookedFromDeveloperDesktop.Enabled');

  const handleChangeSlide = useCallback(() => {
    if (!clicked) {
      tracking.trackPhotoSlideChanged();
      setClicked(true);
    }
  }, [clicked, tracking.trackPhotoSlideChanged]);

  const isAutoScrollActive = useAutoScrollContext();

  if (isFlexibleSanctions && offer.moderationInfo?.photoStub) {
    return <OfferGalleryPessimizationFlexible photoStub={offer.moderationInfo.photoStub} />;
  }

  return (
    <>
      <Gallery
        media={media}
        thumbnails={thumbnails}
        deoptimised={index === 0}
        bookedFromCian={isBookedFromCian}
        bookedFromDeveloper={isBookedFromDeveloper && !isV2BookedFromDeveloperEnabled}
        onChangeSlide={handleChangeSlide}
        autoScroll={isAutoScrollActive}
        autoScrollSettings={autoScrollSettings}
        isNewbuilding={isNewbuilding}
      />
      <OfferLabelsContainer />
      <FeatureLabelsContainer />
    </>
  );
}
